module.exports = __webpack_public_path__ + "img/goods-detail-4.d536be46.jpg";